import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import UserNavbar from "./UserNavbar";
import { useNavigate, useParams } from "react-router-dom";

const RuleContent = () => {
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const role = Cookies.get("role");
  const { filename } = useParams();
  const [content, setContent] = useState("");

  useEffect(() => {
    if (token && role) {
      if (role === "3") {
        navigate("/dashboard");
      }
    }
  }, []);

  useEffect(() => {
    if (!token) {
      navigate("/signin");
    } else {
      axios
        .get("/api/token/isLoggedIn", {
          headers: {
            "x-auth-token": token,
          },
        })
        .then((res) => console.log(res.data))
        .catch(() => navigate("/signin"));
    }
  }, []);

  useEffect(() => {
    axios
      .get(`/api/system/rules/file/${filename}`, {
        headers: {
          "x-auth-token": token,
        },
      })
      .then((res) => setContent(res.data))
      .catch((e) => console.error(e));
  }, []);

  return (
    <>
      <UserNavbar />

      <div className="px-4 lg:pt-10 lg:w-[80vw] xl:w-[85vw] lg:absolute lg:right-0 lg:px-6 xl:absolute xl:right-0  xl:pt-20 xl:pb-12 h-full bg-gray-50">
        <div className="border border-gray-200 rounded-md bg-gray-50 overflow-hidden">
          <div className="p-4">
            <i
              className="cursor-pointer ri-arrow-left-s-line text-blue-500 font-bold text-[1.5rem] pr-2 align-middle"
              onClick={() => navigate("/managerules")}
            ></i>
            {filename}
          </div>
          <textarea
            className="w-full h-[75vh] p-4 font-mono text-sm bg-gray-100 focus:outline-none resize-none"
            value={content}
          />
        </div>
      </div>
    </>
  );
};

export default RuleContent;
